import styled from 'styled-components';
import {theme} from "@styles/theme";

export const LicensePageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const LicenseContentWrapper = styled.div`
  width: calc(100% - 48px);
  height: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const LicenseInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const LicenseUsersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const LicenseInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CopyFileWrapper = styled.div`
  cursor: pointer;
`;

export const BlockWithBorder = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 4px;
  border: 2px solid ${theme.colors.basic06};
  border-radius: ${theme.roundedBig};
  background-color: ${theme.colors.basic08};
`;
